export const getEmptyDto = () => { return { dto: {}, altPNDtoList: null, langDtoList: null, workDtoList: {} } };
export const getEmptyEditDto = () => { return { dto: {}, altPNDtoList: null, langDtoList: null, wtDto: {} } };

export const mergeValueToRef = (valueData, data) => {
  const config = valueData?.config;
  const values = valueData?.value ?? {};
  const destinationDto = config?.dto ? config.dto : "dto";

  data.current[destinationDto] = data.current[destinationDto] || {};

  for (const key in values) {
    if (values[key] === '' && key in data.current[destinationDto]) {
      delete data.current[destinationDto][key];
    } else if (values[key] !== '') {
      data.current[destinationDto][key] = values[key];
    }
  }
};